import { Link } from 'react-router-dom'
import { track } from '@/lib/analytics'
import { useLocale } from '@/i18n/locale'

/**
 * Лид-магнит — последний блок главной: методика стратегической сессии.
 *
 * Зачем: Метрика page_depth = 1.13 — посетители смотрят одну страницу и уходят.
 * Методика — единственное на сайте, что можно забрать и применить сегодня, не
 * оставляя заявку; ссылка «Все гайды» уводит трафик главной в /guides → растит
 * глубину и dwell (поведенческие факторы Яндекса) и путь к конверсии.
 *
 * Одна карточка вместо разворота (аудит 2026-09-21): заголовок «Начните без
 * нас» буквально предлагал не оставлять заявку, а три технических гайда под
 * ним (VPS, OpenClaw, латинское «AI») адресованы не собственнику и делали
 * из главной сайт для айтишников. Гайды остались на своём хабе — /guides
 * ссылается на каждый, с главной туда ведёт «Все гайды».
 *
 * i18n: гайды только на русском (нет /en/guides), поэтому на /en блок скрыт —
 * не выкидываем англоязычного гостя на русскую страницу. COPY.en заполнен
 * заранее: вернуть блок на /en = снять одну проверку, когда появятся /en/guides.
 */

const MAGNET_SLUG = 'strategiya-kompanii-za-odnu-sessiyu'

const COPY = {
  ru: {
    eyebrow: 'Материалы · бесплатно',
    heading: 'Примерьте на себя — без заявки',
    body: 'Методика стратегической сессии с нейросетью: один текстовый файл (.md) отдаёте ей первым сообщением, и она сама ведёт вас от точки А в цифрах до плана на 90 дней. Внутри 12 слоёв и 6 гейтов — контрольных точек, где нейросеть ждёт вашего подтверждения, прежде чем идти дальше. От 40 минут.',
    cta: 'Открыть методику',
    all: 'Все гайды',
  },
  en: {
    eyebrow: 'Further reading · free',
    heading: 'Try it on your own company — no request form',
    body: 'The strategy session method for working with an AI model: one text file (.md) you send as the first message, and the model walks you from point A in numbers to a 90-day plan. Inside are 12 layers and 6 gates — checkpoints where the model waits for your confirmation before moving on. From 40 minutes.',
    cta: 'Open the method',
    all: 'All guides',
  },
}

export function ReadNext() {
  const locale = useLocale()
  if (locale === 'en') return null
  const t = COPY[locale]

  return (
    <section id="read-next" data-plate="off" className="section">
      <div className="container-x">
        {/* Карточка кликабельна целиком через stretched-link на кнопке;
            заголовок и описание остаются вне ссылки. «Все гайды» лежит
            выше растянутой ссылки (relative z-10), иначе клик по ней уходил
            бы в методику. */}
        <article className="relative bg-card border border-divider rounded-card p-6 sm:p-10 grid grid-cols-1 lg:grid-cols-12 gap-x-12 gap-y-8 items-end">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 font-mono text-small uppercase tracking-wider text-muted">
              <span aria-hidden className="inline-block w-1.5 h-1.5 rounded-full bg-accent" />
              {t.eyebrow}
            </div>
            <h2 className="mt-4 text-h3 text-ink font-medium leading-snug max-w-2xl text-balance">{t.heading}</h2>
            <p className="mt-4 text-body text-muted max-w-3xl">{t.body}</p>
          </div>
          <div className="lg:col-span-4 lg:justify-self-end flex flex-col items-start lg:items-end gap-4">
            <Link
              to={`/guides/${MAGNET_SLUG}`}
              onClick={() => track('leadmagnet_click')}
              className="btn-secondary stretched-link no-underline w-full sm:w-auto"
            >
              {t.cta}&nbsp;<span aria-hidden>→</span>
            </Link>
            <Link
              to="/guides"
              onClick={() => track('read_next_all_click')}
              className="relative z-10 font-mono text-small font-medium text-ink hover:text-accent no-underline transition-colors"
            >
              {t.all} <span aria-hidden>→</span>
            </Link>
          </div>
        </article>
      </div>
    </section>
  )
}
